import { ActionEnum } from '../../../actions/types/orderActions.types';
import OrderMassAction from './OrderMassAction';

class UpdateConditions extends OrderMassAction {
  mustShowAction(): boolean {
    return this.allOrdersHaveAction([ActionEnum.OPEN_UPDATE_ORDER_MODAL]);
  }
}

export default UpdateConditions;
